/**
 * AB#2060 (Epic AB#2055) — Pay-at-Salon content cleanup feature flag.
 *
 * Frozen V1 is **pay-at-salon only** — there is no online payment, no
 * marketplace commission, and no payout. This flag gates every
 * online-payment-shaped concept on the Owner Payments page:
 *   - the Commissions and Payouts tabs (and their fetch paths)
 *   - the Stripe PaymentIntent ("Stripe PI") column
 *   - the expandable Stripe payment-detail row (platform fee, net amount,
 *     Stripe dashboard link, Stripe payment id)
 *
 * Default is **OFF** — the page ships in its pay-at-salon shape: a single
 * Transactions view of cash payments the owner marked paid (date,
 * appointment, amount, status, method).
 *
 * The Stripe code is intentionally KEPT (dormant), not deleted. When the
 * platform later turns on online payments, flip this flag to `true` (via
 * `.env.local` / `.env.development` for dogfood, then the Azure Static Web
 * Apps env var for prod) and the Commissions/Payouts tabs, the Stripe PI
 * column, and the payment-detail drawer all light back up unchanged.
 *
 * Environment variable: `REACT_APP_ONLINE_PAYMENTS_ENABLED`
 * (string "true", case-insensitive, to enable).
 */
export const isOnlinePaymentsEnabled = (): boolean =>
    (process.env.REACT_APP_ONLINE_PAYMENTS_ENABLED ?? '').toLowerCase() === 'true';
